module.exports = __webpack_public_path__ + "img/3.1.ccaf3f45.png";